import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class DetailsSidenavService {

  sidenav: MatSidenav;
  regionSn: MatSidenav;

  constructor() { 
    
  }

  setSideNav(sn: MatSidenav): void {
    this.sidenav = sn;
  }

  setRegionSideNav(sn: MatSidenav): void {
    this.regionSn = sn;
  }

  getRegionSideNav(): MatSidenav {
    return this.regionSn;
  }

  getSideNav(): MatSidenav {
    return this.sidenav;
  }

  openSideNav(): void {
    this.sidenav.open();
  }

  closeSideNav(): void {
    this.sidenav.close();
  }

  openRegSideNav(): void {
    this.regionSn.open();
  }

  closeRegSideNav(): void {
    this.regionSn.close();
  }

  
}
